// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphImage.tsx");
  import.meta.hot.lastModified = "1717182690458.633";
}
// REMIX HMR END

import { Image } from "@unpic/react";
export default function ImageComponent({
  image: {
    mediaImage: {
      url,
      width,
      height
    }
  }
}) {
  return <Image width={width} height={height} layout="constrained" className="w-full object-scale-down h-auto my-8" src={url} />;
}
_c = ImageComponent;
var _c;
$RefreshReg$(_c, "ImageComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;